import type {Pinia} from 'pinia'
import {useHttpStore} from '~/composables/stores/http.store'

export default defineNuxtPlugin((nuxtApp) => {
    const pinia = nuxtApp.$pinia as Pinia

    nuxtApp.hook('openFetch:onRequest:nestMain', (ctx) => {
        ctx.options.baseURL = useApiBaseURL()
        ctx.options.credentials = 'include'
    })

    nuxtApp.hook('openFetch:onResponseError:nestMain', (ctx) => {
        handleUnauthorized(ctx.response?.status, pinia)
    })
})

function handleUnauthorized(status: number | undefined, pinia: Pinia) {
    if (status !== 401) {
        return
    }

    const http = useHttpStore(pinia)
    http.pendingLogout = true
}
